export default __webpack_public_path__ + "static/media/notify.7dcc6959.png";